import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { sleep } from 'src/smoothr-web-app-core/utils/utils';

export enum WHERE_USER_COUPON {
	IN_APP = 'in_app',
	IN_RESTAURANT = 'in_restaurant',
}

@Component({
	selector: 'app-select-where-use-coupon',
	templateUrl: './select-where-use-coupon.component.html',
	styleUrls: ['./select-where-use-coupon.component.scss'],
})
export class SelectWhereUseCouponComponent implements OnInit {
	public whereUseCouponEnum = WHERE_USER_COUPON;
	constructor(private modalCtrl: ModalController) {}

	static async show(modalCtrl: ModalController): Promise<WHERE_USER_COUPON> {
		const modal = await modalCtrl.create({
			component: SelectWhereUseCouponComponent,
			cssClass: ' auto-height',
			componentProps: {},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		await sleep(200);
		return result;
	}

	ngOnInit() {}
	close() {
		this.modalCtrl.dismiss();
	}
	selectType(type: WHERE_USER_COUPON) {
		this.modalCtrl.dismiss(type);
	}
}
